<template>
  <div class="editor-content">
    <div class="group">
      <div style="flex: 5;">Table Filters Applied:</div>
      <InputSwitch  v-model="tableFiltered" value="checked" />
      <div style="flex: 3;"></div>
    </div>


    <h6>Cell [{{ selectedCellRow + 1 }}, {{ selectedCellColumn + 1 }}]: </h6>
    <div class="group">
        <span class="label-long">Apply Rule(s): </span>
        <MultiSelect filter v-model="chosenCellRules" :options="rules" optionLabel="name" optionValue="id" placeholder="Select an Action"
                     :maxSelectedLabels="3" :inputStyle="{ width: '120px' }" style="width: 170px;" />

    </div>

    <Divider />

    <h6>Row: {{ selectedCellRow + 1 }}</h6>
    <div class="group">
      <span class="label-long">Apply Rule(s): </span>
      <MultiSelect filter v-model="chosenRowRules" :options="rules" optionLabel="name" optionValue="id" placeholder="Select an Action"
                   :maxSelectedLabels="3" :inputStyle="{ width: '120px' }" style="width: 170px;" />

    </div>


    <Divider />

    <h6>Column {{ selectedCellColumn + 1 }}: </h6>
    <div class="group">
      <span class="label-long">Apply Rule(s): </span>
      <MultiSelect filter v-model="chosenColumnRules" :options="rules" optionLabel="name" optionValue="id" placeholder="Select an Action"
                   :maxSelectedLabels="3" :inputStyle="{ width: '120px' }" style="width: 170px;" />

    </div>

  </div>
</template>

<script setup lang="ts">

import { PropType, computed} from "vue";
import {PPTTableElement, TableFilters} from "@/types/slides";
import {useMainStore, useSlidesStore, useWidgetStore} from "@/store";
import {storeToRefs} from "pinia";

const props = defineProps({
  tableElement: {
    type: Object as PropType<PPTTableElement>,
    required: true,
  },
  selectedCellRow: {
    type: Number,
    required: true
  },
  selectedCellColumn: {
    type: Number,
    required: true
  }
})

const mainStore = useMainStore()
const { tableFiltered } = storeToRefs(mainStore)
const slidesStore = useSlidesStore()

const {rules} = storeToRefs(slidesStore)

let newFilters: TableFilters[] = []


const chosenCellRules = computed({
  get: () => {

    const cellFilter = props.tableElement.filters?.find(
        (filter) => filter.filterOn === 'cell' && filter.rowIndex === props.selectedCellRow && filter.columnIndex === props.selectedCellColumn
    );

    return cellFilter?.ruleIds || [];
  },
  set: (val) => {
    saveFilters(val, 'cell');
  },
});

const chosenColumnRules = computed({
  get: () => {
    const columnFilter = props.tableElement.filters?.find(
        (filter) => filter.filterOn === 'column' && filter.columnIndex === props.selectedCellColumn
    );

    return columnFilter?.ruleIds || [];
  },
  set: (val) => {
    saveFilters(val, 'column');
  },
});

const chosenRowRules = computed({
  get: () => {

    const rowFilter = props.tableElement.filters?.find(
        (filter) => filter.filterOn === 'row' && filter.rowIndex === props.selectedCellRow
    );


    return rowFilter?.ruleIds || [];
  },
  set: (val) => {
    saveFilters(val, 'row');
  },
});


const saveFilters = (val, type) => {
  if (!props.tableElement) return;

  if (val && type == 'cell') {
    const cellFilter = { ruleIds: val, filterOn: type, rowIndex: props.selectedCellRow, columnIndex: props.selectedCellColumn }
    addOrUpdateFilter(cellFilter, ['rowIndex', 'columnIndex'])
  }

  if (val  && type == 'row') {
    const rowFilter = { ruleIds: val, filterOn: type, rowIndex: props.selectedCellRow }
    addOrUpdateFilter(rowFilter, ['rowIndex'])
  }

  if (val && type == 'column') {
    const columnFilter = { ruleIds: val, filterOn: type, columnIndex: props.selectedCellColumn }
    addOrUpdateFilter(columnFilter, ['columnIndex'])
  }


  props.tableElement.filters = props.tableElement.filters
      ? [...new Set([...props.tableElement.filters, ...newFilters])]
      : newFilters
};

const addOrUpdateFilter = (filter: any, keys: string[]) => {
  if (filter.ruleIds) {
    if (keys.every(key => filter[key] !== undefined)) {
      handleFilter(filter, keys);
    }
  }
};

const handleFilter = (newFilter: any, keys: string[]) => {
  let filterExists = false;
  if (props.tableElement.filters) {
    const tableFilters = props.tableElement.filters
    const filterIndex = props.tableElement.filters.findIndex(
        (filter) => keys.every(key => filter[key] === newFilter[key])
    );

    if (filterIndex !== -1) {
      props.tableElement.filters[filterIndex] = newFilter;
      filterExists = true;
    }

  }

  if (!filterExists) {
    newFilters.push(newFilter);
  }
};




</script>

<style scoped>
:deep(.group) {
  display: flex;
  align-items: center;
  column-gap: 10px;
}
</style>
